// extracted by mini-css-extract-plugin
export default {"formContainer":"Delovi_formContainer__OcLvj","accordionContainer":"Delovi_accordionContainer__wx+Ey","buttonSecondary":"Delovi_buttonSecondary__KdQGq","icon":"Delovi_icon__DosTX"};